import React, { useEffect, useState } from 'react'
import { View, Text } from 'react-native'
import { useDispatch } from 'react-redux'
import tw from 'tailwind-rn'

import {
  BlockMenuType,
  BlockStateDistrictsType,
  MenuType,
} from '../../config/types'
import ActionCreators from '../../store/actions'
import { HGText } from '../HGUI'
import BlockMenu from './BlockMenu'

type Props = {
  data: BlockStateDistrictsType
}

const BlockStateDistricts = (props: Props) => {
  const dispatch = useDispatch()
  const { data } = props
  const {
    // id,
    state: { id: stateId },
    locationTypes,
  } = data
  const [loading, setLoading] = useState<boolean>(false)
  const [districts, setDistricts] = useState<BlockMenuType | null>(null)

  useEffect(() => {
    setLoading(true)
    dispatch(ActionCreators.loadDistrictsOfState({ stateId, locationTypes }))
      .then((result: Array<unknown>) => {
        let districtItems: Array<MenuType> = []

        if (result && result.length > 0) {
          districtItems = result.map((d) => {
            return {
              type: 'locations',
              id: d.id,
              title: d.title,
              description: d.description,
              // state: d.state,
              districtId: d.id,
              locationTypes,
            }
          })
        }

        const districtsAsMenu: BlockMenuType = {
          id: stateId,
          type: 'menu',
          items: districtItems,
        }
        setDistricts(districtsAsMenu)
      })
      .catch()
      .then(() => setLoading(false))
  }, [])

  return (
    <View style={tw('pb-6')}>
      {!loading && districts && districts.items.length === 0 && (
        <>
          <View style={tw('flex items-center')}>
            <Text style={tw('mt-6 mb-3 text-4xl')}>🏥</Text>
            <HGText style={{ textAlign: 'center' }}>
              Für dieses Bundesland gibt es noch keine Standorte.
            </HGText>
          </View>
        </>
      )}
      {districts && <BlockMenu data={districts} />}
      {/* <Markdown>{content}</Markdown> */}
    </View>
  )
}

export default BlockStateDistricts
